import { render, staticRenderFns } from "./PrivacyTerms.vue?vue&type=template&id=bdd3101c&scoped=true"
import script from "./PrivacyTerms.vue?vue&type=script&lang=ts"
export * from "./PrivacyTerms.vue?vue&type=script&lang=ts"
import style0 from "./PrivacyTerms.vue?vue&type=style&index=0&id=bdd3101c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdd3101c",
  null
  
)

export default component.exports